/** Where sign-in comes back to, kept for this tab. */
export const NEXT_KEY = "gd.signin.next";

/** This page's address in the app: what sign-in should come back to. */
export function here() {
  return location.pathname + location.search || "/";
}

/** Opens the sign-in screen, coming back to `path` afterwards. */
export function signInFrom(path: string) {
  try {
    sessionStorage.setItem(NEXT_KEY, path);
  } catch {
    // storage refused: sign-in comes back home
  }
  location.assign("/");
}
